import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@/lib/i18n';
import { ArrowLeft } from '@phosphor-icons/react';

export default function Datenschutz() {
  const { t } = useI18n();

  useEffect(() => {
    window.scrollTo({ top: 0 });
    document.title = 'Datenschutz – De Melo Recruiting';
  }, []);

  return (
    <div data-testid="datenschutz-page" className="bg-white min-h-screen pt-32 pb-24 md:pb-32">
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <Link to="/" data-testid="datenschutz-back" className="inline-flex items-center gap-2 text-[#C5A059] hover:text-[#0A1128] text-[12px] tracking-[0.22em] uppercase font-semibold transition-colors">
          <ArrowLeft size={16} weight="bold" /> {t.legal.back}
        </Link>
        <div className="eyebrow text-[#C5A059] mt-10">{t.legal.privacyEyebrow}</div>
        <h1 className="heading-display mt-4 text-[#0A1128] text-4xl sm:text-5xl">Datenschutz­erklärung</h1>
        <div className="mt-3 h-px w-12 bg-[#C5A059]" />

        <div className="mt-12 space-y-10 text-[#1E2229]/85 text-[15px] leading-relaxed">
          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">1. Verantwortlicher</h2>
            <p>
              Verantwortlich für die Datenverarbeitung im Sinne der DSGVO ist:<br/>
              De Melo Recruiting, Inh. Thiago Pereira Casanova de Melo<br/>
              Buchenstraße 14, 79108 Freiburg im Breisgau<br/>
              Telefon: +49 152 08483930<br/>
              E-Mail: <a href="mailto:info@demelo-recruiting.de" className="text-[#C5A059] hover:underline">info@demelo-recruiting.de</a>
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">2. Allgemeines zur Datenverarbeitung</h2>
            <p>Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers oder wenn die Verarbeitung durch gesetzliche Vorschriften gestattet ist.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">3. Bereitstellung der Website und Erstellung von Logfiles</h2>
            <p>Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten (z. B. IP-Adresse, Datum/Uhrzeit, übertragene Datenmenge, Browser-Typ). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer sicheren Bereitstellung).</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">4. Kontakt- und Bewerbungsformular</h2>
            <p>Wenn Sie uns über unser Kontaktformular oder das Bewerbungsformular Anfragen zukommen lassen, werden Ihre Angaben (Name, Unternehmen, Telefon, E-Mail, Nachricht, ggf. Lebenslauf) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
            <p className="mt-3">Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sowie auf Basis unseres berechtigten Interesses an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO). Im Falle einer Bewerbung erfolgt die Verarbeitung zur Anbahnung eines Beschäftigungsverhältnisses (§ 26 BDSG).</p>
            <p className="mt-3">Bewerbungs- und Anfragedaten werden gelöscht, sobald sie für den Zweck der Verarbeitung nicht mehr erforderlich sind, spätestens nach 6 Monaten – sofern keine gesetzlichen Aufbewahrungs­pflichten oder Ihre Einwilligung zur längeren Speicherung vorliegen.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">5. E-Mail-Versand über Resend</h2>
            <p>Für den zuverlässigen Versand der über das Kontakt-/Bewerbungsformular eingehenden E-Mails nutzen wir den Dienst <strong>Resend (Resend, Inc.)</strong>. Hierbei werden die übermittelten Inhalte (Name, E-Mail, Nachricht, ggf. Anhänge) an Resend übergeben. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Weitere Informationen: <a href="https://resend.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] hover:underline">resend.com/legal/privacy-policy</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">6. Google Maps</h2>
            <p>Unsere Website nutzt zur Darstellung des Standorts einen eingebetteten Google-Maps-Frame (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland). Beim Aufruf wird Ihre IP-Adresse an Google übertragen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Datenschutzerklärung von Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C5A059] hover:underline">policies.google.com/privacy</a>.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">7. Cookies</h2>
            <p>Diese Website setzt technisch notwendige Cookies (z. B. zur Speicherung der Sprachwahl). Es werden keine Tracking-Cookies ohne Ihre Einwilligung gesetzt. Sie können das Setzen von Cookies in Ihrem Browser jederzeit deaktivieren.</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">8. Ihre Rechte</h2>
            <p>Sie haben gegenüber uns als Verantwortlichem folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:</p>
            <ul className="mt-3 list-disc list-inside space-y-1 text-[#1E2229]/85">
              <li>Recht auf Auskunft (Art. 15 DSGVO)</li>
              <li>Recht auf Berichtigung (Art. 16 DSGVO)</li>
              <li>Recht auf Löschung (Art. 17 DSGVO)</li>
              <li>Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
              <li>Recht auf Datenübertragbarkeit (Art. 20 DSGVO)</li>
              <li>Widerspruchsrecht (Art. 21 DSGVO)</li>
              <li>Recht auf Widerruf einer Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
            </ul>
            <p className="mt-3">Sie haben außerdem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO).</p>
          </section>

          <section>
            <h2 className="font-display text-xl text-[#0A1128] mb-3">9. Aktualität und Änderungen</h2>
            <p>Diese Datenschutzerklärung ist aktuell gültig. Durch die Weiterentwicklung unserer Website oder geänderter gesetzlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern.</p>
          </section>

          <p className="text-[#64748B] text-sm pt-6 border-t border-[#E2E8F0]">
            Wir empfehlen vor dem Live-Gang eine rechtliche Prüfung durch einen Fachanwalt für IT-Recht.
          </p>
        </div>
      </div>
    </div>
  );
}
